// scarsRemovalData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const scarsRemoval: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best Scars Removal Treatment in Dubai | Effective Scar Reduction",
            "description": "Professional scar removal treatments in Dubai to reduce the appearance of acne scars, surgical scars and more. Get smoother, clearer skin with our advanced procedures. Book your consultation today.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/scars-removal/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best Scars Removal Treatment in Dubai | Effective Scar Reduction",
                "description": "Professional scar removal treatments in Dubai to reduce the appearance of acne scars, surgical scars and more. Get smoother, clearer skin with our advanced procedures. Book your consultation today.",
                "url": "https://elitebodyhome.com/services/scars-removal/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Scars Removal Treatment Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best Scars Removal Treatment in Dubai | Effective Scar Reduction",
                "description": "Professional scar removal treatments in Dubai to reduce the appearance of acne scars, surgical scars and more. Get smoother, clearer skin with our advanced procedures. Book your consultation today.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Scars Removal"],
        "hero": {
            "title": "Scars Removal",
            "subtitle": "",
            "description": "Scars may result in both emotional and physical trauma, in terms of self-consciousness and perceived beauty. Whether from acne, injury, surgery or other reasons, scars can sometimes be a lasting reminder of defects in the skin. Here at Elite Body Home Polyclinic we have some of the latest treatments for getting rid of scars and getting evenly smooth skin back."
        },
        "howItWorks": {
            "title": "Scar Removal Procedure",
            "description": "At Elite Body Home, we offer state-of-the-art scar removal treatments that reduce the appearance of scars by breaking down scar tissue and stimulating new, healthy tissue to develop. Discover curated options to customize your perfect skincare routine for achieving clear, glowing skin."
        },
        "procedureSteps": {
            "heading": "Our Scar Removal Treatments",
            "para": "",
            "steps": [
                {
                    "title": "Microneedling",
                    "desc": "Promotes collagen production by creating micro-injuries that help smooth out scar tissue.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Chemical Peels",
                    "desc": "Remove the top layer of skin, lessening the appearance of shallow scars over time.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "PRP Therapy",
                    "desc": "Uses platelet-rich plasma to stimulate skin repair and collagen production.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "PRX-T33 Peel",
                    "desc": "Advanced peel that stimulates collagen without downtime for scar reduction.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Derma Pen",
                    "desc": "Precision microneedling device for targeted scar reduction and skin renewal.",
                    "icon": "fa-solid fa-pen"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Scar Removal",
            "subheading": "",
            "para": "There are so many reasons to want to remove a scar. In treating the appearance of scars, these treatments can also improve the texture and tone of your skin.",
            "items": [
                {
                    "title": "Improved Skin Texture",
                    "desc": "Smoothing the surface of the skin as the scars are made less visible.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Enhanced Confidence",
                    "desc": "Most patients experience an increase in self-esteem as their scars diminish.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Tailored Treatments",
                    "desc": "Every treatment is individualized to the type of scar and one's own skin for best results.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Most of the scar removal remedies are non-invasive and have no down time.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Before getting scar removal, it's important to know if you are a good candidate for these procedures. The procedures are generally applicable to most, if not all, individuals with unwanted scars; however, the controlled healing response and efficacy of these procedures may vary depending on the person's individual tendencies.",
            "items": [
                {
                    "title": "People with acne scars",
                    "desc": "Effective for reducing the appearance of post-acne scarring.",
                    "icon": "fa-solid fa-bacteria"
                },
                {
                    "title": "Surgical scar patients",
                    "desc": "Can help minimize the visibility of post-surgical scars.",
                    "icon": "fa-solid fa-scalpel"
                },
                {
                    "title": "Trauma scar sufferers",
                    "desc": "Reduces the appearance of scars from injuries or accidents.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Keloid-prone individuals",
                    "desc": "Specialized treatments available for raised keloid scars.",
                    "icon": "fa-solid fa-mountain"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Preparation is key for obtaining the optimal results. Here are some of the ways to do it.",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "A consultation with our dermatologist is mandatory for all the procedures to discuss and check it out what is the best treatment option for each scar and skin type.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Try to keep the area of treatment out of direct sunlight for a minimum of 2 weeks before you come as tanned or sun damaged skin can effect results.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Stop Certain Medications",
                    "desc": "Some medicines, like blood thinners or retinoids, may have to be stopped before treatment begins.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Hydrate & Moisturize",
                    "desc": "Ensuring you keep your skin well-hydrated and moisturized will prepare it to be in good condition for the process.",
                    "icon": "fa-solid fa-droplet"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "There are effective scar removal treatments that can make things a lot better but the results may vary with the method used and the type of skin the individual have and on the scar itself. The vast majority of patients have a marked improvement in the visibility of their scars, with more even, smoother skin texture.",
            "items": [
                {
                    "title": "Immediate Improvements",
                    "desc": "First treatments such as chemical peels and microneedling demonstrate early improvements over several days.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Gradual Healing",
                    "desc": "Laser treatments and steroid injections can take a few weeks to exhibit the full effect as collagen production ramps up.",
                    "icon": "fa-solid fa-seedling"
                },
                {
                    "title": "Long-Term Effects",
                    "desc": "With adequate care, the stimulating effects of scar removal on the skin can last for years.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How many treatments are needed?",
                    "answer": "The number of treatments varies depending on the type of scar and the chosen procedure. Some patients see results after 1-3 sessions, while others may require additional sessions for deeper scars."
                },
                {
                    "question": "Does scar removal hurt?",
                    "answer": "Most treatments are associated with minimal discomfort. Numbing creams are often used to ensure the procedure is as painless as possible."
                },
                {
                    "question": "Are results permanent?",
                    "answer": "Results are generally long-lasting, but some scars may not disappear completely. Maintenance treatments might be necessary for optimal results, especially for keloids or hypertrophic scars."
                },
                {
                    "question": "What are the risks?",
                    "answer": "Potential side effects can include redness, swelling, or temporary skin sensitivity. Our team takes every precaution to minimize risks."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-1-scaled.jpg",
            "beforeAfter": [
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Scars-Removal-in-dubai-EBH-1.jpg", "alt": "scars removal treatment" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Scars-Removal-in-dubai-EBH-2.jpg", "alt": "best scars removal treatment" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Scars-Removal-in-dubai-EBH-3.jpg", "alt": "scars removal treatment" }
            ]
        },
        "product": {
            "id": 316,
            "title": "Scars Removal Package",
            "price": 799,
            "description": "Comprehensive scars removal package including consultation, treatment sessions, and follow-up care. Our expert team offers effective scar reduction solutions tailored to your skin."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل علاج لإزالة الندوب في دبي | تقليل مظهر الندوب",
            "description": "علاجات احترافية لإزالة الندوب في دبي لتقليل مظهر ندوب حب الشباب، الندوب الجراحية وغيرها. احصل على بشرة أكثر نعومة وصفاءً مع إجراءاتنا المتطورة. احجز استشارتك اليوم.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/scars-removal/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل علاج لإزالة الندوب في دبي | تقليل مظهر الندوب",
                "description": "علاجات احترافية لإزالة الندوب في دبي لتقليل مظهر ندوب حب الشباب، الندوب الجراحية وغيرها. احصل على بشرة أكثر نعومة وصفاءً مع إجراءاتنا المتطورة. احجز استشارتك اليوم.",
                "url": "https://elitebodyhome.com/ar/services/scars-removal/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج إزالة الندوب دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل علاج لإزالة الندوب في دبي | تقليل مظهر الندوب",
                "description": "علاجات احترافية لإزالة الندوب في دبي لتقليل مظهر ندوب حب الشباب، الندوب الجراحية وغيرها. احصل على بشرة أكثر نعومة وصفاءً مع إجراءاتنا المتطورة. احجز استشارتك اليوم.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة الندوب"],
        "hero": {
            "title": "إزالة الندوب",
            "subtitle": "",
            "description": "قد تأثر الندوب على المزاج والثقة بالنفس حيث تظهر كتذكير دائم بعيوب سطح الجلد، سواء كانت ناتجة عن حب الشباب، أو إصابة، أو جراحة، أو أسباب أخرى. نوفر في عيادات ايليت بودي هوم أحدث طرق للتخلص من الندوب واستعادة نعومة البشرة وتجانسها."
        },
        "howItWorks": {
            "title": "إجراء إزالة الندوب",
            "description": "نقدم في ايليت بودي هوم تقنيات متطورة لعلاج الندوب، تعمل على تقليل مظهرها من خلال تكسير الأنسجة التالفة وتحفيز نمو أنسجة جديدة وصحية. اكتشف مجموعة من الخيارات المصممة لتخصيص روتين العناية بالبشرة الأمثل للحصول على بشرة نقية ومشرقة."
        },
        "procedureSteps": {
            "heading": "علاجات إزالة الندوب المتوفرة لدينا",
            "para": "",
            "steps": [
                {
                    "title": "الميكرونيديلنغ",
                    "desc": "يعمل على إحداث جروح دقيقة في سطح الجلد لتحفيز إنتاج الكولاجين وإعادة بناء الأنسجة المتضررة، مما يساهم في تحسين ملمس الجلد وتقليل بروز الندبة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "التقشير الكيميائي",
                    "desc": "يساعد على إزالة الطبقة السطحية من الجلد تدريجياً، مما يقلل من مظهر الندوب السطحية بمرور الوقت.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "العلاج بالبلازما الغنية بالصفائح الدموية",
                    "desc": "يستخدم عوامل النمو المستخلصة من دم المريض لتحفيز تجديد خلايا البشرة وتعزيز إنتاج الكولاجين، مما يؤدي إلى تحسين مظهر الندوب.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "تقشير PRX-T33",
                    "desc": "تقشير متطور يحفز الكولاجين دون الحاجة لفترة تعافي طويلة، مما يساعد على تقليل مظهر الندوب.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "الديرما بن",
                    "desc": "جهاز دقيق للميكرونيدلينغ يستهدف الندوب بشكل مباشر لتحفيز تجديد الجلد وتحسين مظهره.",
                    "icon": "fa-solid fa-pen"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد إزالة الندوب",
            "subheading": "",
            "para": "توجد العديد من الأسباب التي تدفع الأفراد إلى الرغبة في إزالة الندوب، حيث يساهم العلاج في تحسين ملمس الجلد وتوحيد لونه.",
            "items": [
                {
                    "title": "تحسين ملمس البشرة",
                    "desc": "يساهم العلاج في تنعيم سطح الجلد وجعل مظهر الندوب أقل وضوحاً.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يشعر معظم المرضى بزيادة في مستوى الثقة بالنفس مع تحسن مظهر الندوب تدريجياً.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "توفير خطط علاجية مخصصة",
                    "desc": "تُصمم كل خطة علاج حسب نوع الندبة والبشرة لتحقيق أفضل النتائج الممكنة.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "لا يتطلب فترة تعافي طويلة",
                    "desc": "تُعد معظم طرق العلاج المتوفرة لإزالة الندوب غير جراحية ولا تتطلب فترة تعافٍ طويلة.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يجب التأكد من مدى ملاءمة الحالة للعلاج قبل البدء. تناسب هذه الإجراءات معظم من يعانون من ندوب غير مرغوب بها، ولكن تعتمد فاعلية العلاج وسرعة ظهور النتائج بشكل كبير على طبيعة البشرة واستجابتها الفردية لعملية التجدد والشفاء.",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من ندوب حب الشباب",
                    "desc": "علاجات فعالة لتقليل مظهر الندوب الناتجة عن حب الشباب.",
                    "icon": "fa-solid fa-bacteria"
                },
                {
                    "title": "المرضى الذين خضعوا لعمليات جراحية",
                    "desc": "يمكن أن يساعد في تقليل ظهور الندوب الناتجة عن العمليات الجراحية.",
                    "icon": "fa-solid fa-scalpel"
                },
                {
                    "title": "الأشخاص الذين يعانون من ندوب الإصابات",
                    "desc": "يقلل من مظهر الندوب الناتجة عن الحوادث أو الإصابات.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "الأشخاص المعرضون للندوب الكيلويدية",
                    "desc": "تتوفر علاجات متخصصة للندوب الكيلويدية المرتفعة عن سطح الجلد.",
                    "icon": "fa-solid fa-mountain"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يُّعد التحضير الجيد خطوة أساسية لتحقيق أفضل النتائج. فيما يلي أهم الإرشادات التي يجب اتباعها قبل بدء العلاج:",
            "items": [
                {
                    "title": "الاستشارة",
                    "desc": "يجب إجراء استشارة مع طبيب الجلدية قبل الخضوع لأي إجراء، حيث يتم تقييم نوع الندبة والبشرة لاختيار الخطة العلاجية الأنسب.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "يُفضل تجنب تعرض المنطقة المستهدفة لأشعة الشمس المباشرة أو جلسات التان لمدة لا تقل عن أسبوعين قبل الجلسة، حيث قد لا تستجيب البشرة المصابة بحروق للعلاج بالشكل المطلوب.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "إيقاف بعض الأدوية",
                    "desc": "قد يُطلب منك التوقف عن بعض الأدوية مثل مميعات الدم أو الريتينويدات قبل الجلسات، حسب توصية الطبيب.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الترطيب الجيد للبشرة",
                    "desc": "يساعد الحفاظ على ترطيب البشرة بشكل كافٍ قبل العلاج في تهيئتها وتحسين فاعلية الجلسة.",
                    "icon": "fa-solid fa-droplet"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "تعتبر طرق إزالة الندوب فعالة في تحسين مظهر البشرة بشكل ملحوظ، ولكن قد تختلف النتائج من شخص لآخر حسب نوع الندبة وطبيعة البشرة وطريقة العلاج المستخدمة. يحقق أغلب المرضى تحسنًا واضحًا في مظهر الندوب، مع نسيج بشرة أكثر نعومة وتناسقًا.",
            "items": [
                {
                    "title": "تحسن فوري",
                    "desc": "تحقق بعض أنواع العلاج مثل التقشير الكيميائي الميكرونيدلينغ نتائج أولية خلال أيام قليلة بعد الجلسة.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "شفاء تدريجي",
                    "desc": "تتطلب بعض أنوع العلاج أسابيع حتى تظهر نتائجها الكاملة مع تحفيز إنتاج الكولاجين في الجلد، مثل العلاج بالليزر وإبر الستيرويد.",
                    "icon": "fa-solid fa-seedling"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "يمكن أن تدوم تأثيرات تحفيز البشرة وتحسين مظهر الندوب لسنوات مع العناية المناسبة بالبشرة بعد العلاج.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم عدد الجلسات المطلوبة؟",
                    "answer": "يعتمد عدد الجلسات على نوع الندبة والإجراء المستخدم. يلاحظ بعض المرضى تحسناً بعد 1 إلى 3 جلسات، بينما قد تتطلب الندوب العميقة جلسات إضافية لتحقيق نتائج أفضل."
                },
                {
                    "question": "هل إزالة الندوب مؤلمة؟",
                    "answer": "تُجرى غالبية أنواع العلاج مع قدر بسيط من الانزعاج، وغالبًا ما يُستخدم كريم مخدر لتقليل الشعور بأي ألم وجعل الإجراء مريحًا قدر الإمكان."
                },
                {
                    "question": "هل النتائج دائمة؟",
                    "answer": "تكون النتائج غالبًا طويلة الأمد، لكن قد لا تختفي بعض الندوب تمامًا، وقد تكون هناك حاجة إلى جلسات عناية للحفاظ على النتائج في حالات مثل الندوب الكلويد أو الندوب المتضخمة."
                },
                {
                    "question": "ما هي المخاطر المحتملة؟",
                    "answer": "تشمل الآثار الجانبية المحتملة احمرارًا مؤقتًا، أو تورمًا خفيفًا، أو حساسية مؤقتة في الجلد. يحرص فريقنا دائمًا على اتخاذ جميع الإجراءات اللازمة لتقليل أي مخاطر وضمان تجربة علاج آمنة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
}
